import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";
import type { components } from "../../api/schema.gen";

export type PnlEvent = components["schemas"]["PnlHistoryEventDTO"];

export const PNL_HISTORY_KEY = ["positions", "pnl-history"] as const;

// Датированная история реализованного P&L (купоны + продажи + погашения) с
// нарастающим итогом — считается на бэке из trades. Основа equity-кривой.
export function useStatsHistory() {
  return useQuery({
    queryKey: PNL_HISTORY_KEY,
    queryFn: async ({ signal }) => {
      const { data, error } = await api.GET("/api/positions/pnl-history", {
        signal,
      });
      if (error || !data) throw new Error(String(error ?? "no data"));
      return data;
    },
    staleTime: 30_000,
  });
}
